import { render, staticRenderFns } from "./smartreview.vue?vue&type=template&id=da68193e&scoped=true&lang=pug"
import script from "./smartreview.vue?vue&type=script&lang=ts"
export * from "./smartreview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da68193e",
  null
  
)

export default component.exports